// Farbverweise in gespeicherten Projektdaten finden (F7 Hinweis, F8 Verwendung).
// Rein und ohne Registry: Die Umrechnung in Revisionsschlüssel (`katalog:code`)
// übergibt der Aufrufer (`keyOf`), damit Browser und Backend dieselbe Suche
// mit ihrer jeweiligen Normalisierung nutzen.
//
// Erkannt werden
// - Farbobjekte mit `catalog`/`catalogKey` und `code` (heutiges Speicherformat),
// - Codetexte unter farbbezogenen Schlüsseln (z. B. `color`, `decor`, `material`),
//   so wie Systeme ohne Farbobjekte sie speichern (`RAL9018`, `W10141`, `galvanized`),
// - ausdrückliche RAL-/NCS-Codes an beliebiger Stelle.
// Die Auftragsbindung selbst wird übersprungen.

const COLOR_KEY_HINT = /(?:decor|dekor|colou?r|farbe|material|finish|oberflaeche|oberfläche)/i;
const EXPLICIT_CODE = /^(?:RAL\s*\d{4}|NCS\s+S?\s*\d{4}-[A-Z0-9]+)$/i;
const SKIPPED_KEYS = new Set(['colorCatalogBinding']);

export function collectColorReferences(root, keyOf, { maxNodes = 2_000_000 } = {}) {
  const found = new Map();
  if (typeof keyOf !== 'function') return found;
  const add = value => {
    let key;
    try { key = keyOf(value); } catch (_error) { return; }
    if (typeof key === 'string' && key) found.set(key, (found.get(key) || 0) + 1);
  };
  const seen = new Set();
  const stack = [[root, '']];
  let visited = 0;
  while (stack.length) {
    const [value, parentKey] = stack.pop();
    if (++visited > maxNodes) break;
    if (typeof value === 'string') {
      const text = value.trim();
      if (!text || text.length > 80) continue;
      if (COLOR_KEY_HINT.test(parentKey) || EXPLICIT_CODE.test(text)) add(text);
      continue;
    }
    if (!value || typeof value !== 'object' || seen.has(value)) continue;
    seen.add(value);
    if (Array.isArray(value)) {
      for (let index = value.length - 1; index >= 0; index--) stack.push([value[index], parentKey]);
      continue;
    }
    const catalog = typeof value.catalog === 'string' ? value.catalog : value.catalogKey;
    if (typeof catalog === 'string' && catalog && typeof value.code === 'string' && value.code) {
      add(value);
      continue;
    }
    for (const [key, entry] of Object.entries(value)) {
      if (!SKIPPED_KEYS.has(key)) stack.push([entry, key]);
    }
  }
  return found;
}
